import cx from 'clsx';
import type React from 'react';

type Props = {
  className?: string;
  children?: React.ReactNode;
  direction?: 'horizontal' | 'vertical';
};

export const Divider = ({ className, children, direction = 'horizontal' }: Props) => {
  const isVertical = direction === 'vertical';

  return (
    <div className={cx('relative', !isVertical && 'w-full', isVertical && 'flex h-auto flex-col justify-center', className)}>
      <div className={cx('absolute inset-0 flex', !isVertical && 'items-center', isVertical && 'justify-center')}>
        <div aria-hidden="true" className={cx('border-gray-300', !isVertical && 'w-full border-b', isVertical && 'h-full w-px border-l')} />
      </div>
      {children && (
        <div className={cx('relative flex', !isVertical && 'justify-center', isVertical && 'items-center')}>
          <span className={cx('bg-white text-gray-500 text-sm', !isVertical && 'px-4', isVertical && 'origin-center rotate-[-90deg] py-1')}>{children}</span>
        </div>
      )}
    </div>
  );
};
